var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgVegetarian = function SvgVegetarian(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 41 40",
    width: "1em",
    height: "1em"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.58 35.167A12.553 12.553 0 0 1 5.028 22.613c0-18.205 21.907-8.86 32.454-17.613a.776.776 0 0 1 .798-.08.833.833 0 0 1 .5.63C42 24.405 28.12 35.167 17.58 35.167Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.602 19.257A41.64 41.64 0 0 0 8.253 26.4L1.75 31.95"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h40v40H0z",
    transform: "translate(.5)"
  })))));
};
export default SvgVegetarian;